// ClientRequestsExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportClientRequestsExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Client Requests");
  const t = i18n.t.bind(i18n);
  const formatSubscription = (value) => {
  if (!value) return "";
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
  // Define columns
   worksheet.columns = [
    { header: t("ClientsRequests.columns.id"), key: "id", width: 10 },
    { header: t("ClientsRequests.columns.admin"), key: "admin", width: 20 },
    { header: t("ClientsRequests.columns.company"), key: "company", width: 25 },
    { header: t("ClientsRequests.columns.country"), key: "country", width: 15 },
    { header: t("ClientsRequests.columns.users"), key: "Users", width: 12 },
    { header: t("ClientsRequests.columns.email"), key: "email", width: 30 },
    { header: t("ClientsRequests.columns.subscription"), key: "subscription", width: 20 },
    { header: t("ClientsRequests.columns.status"), key: "status", width: 15 },
    { header: t("invites.columns.verificationStatus"), key: "verificationStatus", width: 20 },
    { header: t("ClientsRequests.columns.date"), key: "created_at", width: 25 },
  ];
  const formattedData = data.map((item) => ({
    ...item,
    subscription: item.subscription
      ? formatSubscription(item.subscription)
      : "-",
  }));
  // Add rows
 worksheet.addRows(formattedData);

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" }, // dark blue background
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Export as Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Client_Requests.xlsx");
};

export default ExportClientRequestsExcel;
